import { useEffect } from "react"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { v1FetchRatingTrips } from "@be-miniapp/api"
import { useFirstLocation } from "@be-miniapp/ui/hooks/use-first-location"
import { useNavigate } from "@be-miniapp/ui/hooks/use-navigate"

interface UseTripRatingProps {
  enabled?: boolean
}
export function useTripRating({ enabled }: UseTripRatingProps) {
  const pathname = useFirstLocation()

  const { data: ratingTrips } = useQuery({
    queryKey: ["rating-trips"],
    queryFn: async () => {
      return v1FetchRatingTrips()
    },
    refetchOnWindowFocus: true,
    placeholderData: keepPreviousData,
    enabled: pathname === "/ride/home" && enabled,
    gcTime: 0,
  })

  const navigate = useNavigate()

  useEffect(() => {
    if (pathname !== "/ride/home") return

    const filteredTrips =
      ratingTrips?.ratings?.filter((rating) => rating.type === 1) || []

    if (ratingTrips?.flag === 143 && filteredTrips.length > 0) {
      if (!filteredTrips?.[0]?.can_rate_driver) {
        return
      }

      navigate("/ride/finish", {
        state: {
          engagement: filteredTrips[0],
        },
      })
    }
  }, [ratingTrips, pathname, navigate])
}
